<template>
  <div ref="container" class="bill-details">
    <div class="nav acea-row">
      <div
        class="item"
        v-for="(item, index) in status"
        :key="index"
        :class="selectIndex == index ? 'on' : ''"
        @click="changeTypes(index)"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="coupon-list" v-if="couponsList.length > 0">
      <div
        class="item acea-row row-center-wrapper"
        v-cloak
        v-for="(item, index) in couponsList"
        :key="index"
      >
        <div class="money" :class="item.is_expire ? 'moneyGray' : ''">
          ￥<span class="num">{{ item.price }}</span>
        </div>
        <div class="text">
          <div class="condition line1">{{ item.name }}</div>
          <div class="data acea-row row-between-wrapper">
            <div v-if="item.end_time === 0">不限时</div>
            <div v-else>{{ item.begin_time }}-{{ item.end_time }}</div>
            <div
              class="bnt bg-color-red"
              v-if="selectIndex == 0"
              @click="lq(item.id)"
            >
              立即领取
            </div>
            <div class="bnt gray" v-else-if="item.is_use">
              {{ item.status_msg }}
            </div>
            <div class="bnt bg-color-red" v-else>{{ item.status_msg }}</div>
          </div>
        </div>
      </div>
    </div>
    <!--暂无优惠券-->
    <div
      class="noCommodity"
      v-else-if="couponsList.length === 0 && loading === true"
    >
      <div class="noPictrue">
        <img src="@assets/images/noCoupon.png" class="image" />
      </div>
    </div>
  </div>
</template>
<style scoped>
.nav {
  position: fixed;
}
.coupon-list {
  margin-top: 1rem;
}
</style>
<script>
import {
  getCouponsUser,
  getCouponReceive,
  getCoupon,
  getCouponGetOne
} from "@api/user";
const NAME = "UserCoupon";

export default {
  name: "UserCoupon",
  components: {},
  props: {},
  data: function() {
    return {
      couponsList: [],
      loading: false,
      loaded: false,
      status: [
        {
          name: "可领取",
          filters: {}
        },
        {
          name: "未使用",
          filters: { is_use: 0 }
        },
        {
          name: "已使用",
          filters: { is_use: 1 }
        },
        {
          name: "已过期",
          filters: { is_expire: 1 }
        }
      ],
      selectIndex: 0,
      where: {
        page: 1,
        page_size: 20
      },
      coupon_id: ""
    };
  },
  watch: {
    $route: function(n) {
      var that = this;
      if (n.name === NAME) {
        that.getUseCoupons();
      }
    }
  },
  mounted: function() {
    this.coupon_id = Number(this.$route.query.coupon_id);

    if (this.coupon_id) {
      this.getCouponGetOne(this.coupon_id);
    } else {
      const select = Number(this.$route.query.type);
      if (select) {
        this.selectIndex = select;
        this.changeTypes(select);
      }
      this.getUseCoupons();
      this.$scroll(this.$refs.container, () => {
        !this.loading && this.getUseCoupons();
      });
    }
  },
  methods: {
    changeTypes(i) {
      this.where.page = 1;
      this.selectIndex = i;
      this.loaded = false;
      if (this.coupon_id) {
        // this.getCouponGetOne(this.coupon_id)
      } else {
        this.getUseCoupons();
      }
    },
    lq(coupon_id) {
      if (this.coupon_id) coupon_id = this.coupon_id;
      getCouponReceive({ coupon_id })
        .then(() => {
          this.$dialog.toast({ mes: "领券成功！" });
          this.$emit("success");
          // this.$router.push('/user/user_coupon?type=1')
          location.href = "/user/user_coupon?type=1";
        })
        .catch(err => {
          this.$dialog.error(err);
        });
    },
    getCouponGetOne(coupon_id) {
      if (this.loaded == true || this.loading == true) return;
      this.loading = true;
      getCouponGetOne({ coupon_id })
        .then(res => {
          res.data = res.data || [];
          this.loaded = !res.data || res.data.length < this.where.page_size;
          res.data && this.couponsList.push(res.data);
          console.log("coupon list", this.couponsList);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getUseCoupons() {
      if (this.loaded == true || this.loading == true) return;
      this.loading = true;
      let $fun = this.selectIndex == 0 ? getCoupon : getCouponsUser;
      $fun({ ...this.where, ...this.status[this.selectIndex].filters })
        .then(res => {
          res.data = res.data || [];
          if (this.where.page == 1) this.couponsList = [];
          this.loaded = !res.data || res.data.length < this.where.page_size;
          this.where.page = this.where.page + 1;
          this.couponsList.push.apply(this.couponsList, res.data);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
